  import React, { useState, useEffect } from "react";
  import { useNavigate } from "react-router";
  import { useSelector, useDispatch } from "react-redux";
  import { useToast } from "../../Hooks/useToast";

  import Box from "@mui/material/Box";
  import Button from "@mui/material/Button";
  import TextField from "@mui/material/TextField";
  import InputAdornment from "@mui/material/InputAdornment";
  import SearchIcon from "@mui/icons-material/Search";
  import { DatePicker } from "@mui/x-date-pickers/DatePicker";
  import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
  import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
  import { Formik, Form, Field } from "formik"
  import * as Yup from "yup";

  import  MenuItem  from "@mui/material/MenuItem";

  import MainHeader from "../../Components/Headres/Main_Header";
  import DatagridTable from "../../Components/Table/DataGrid_Table";
  import { createColumn } from "../../Components/Table/DataGrid_Cullums";
  import CellImg from "../../Components/Table/Cell_Img";
  import AccoCodeModal from "./ACC_Code_Modal";

  import { FetchEditReservations } from "../../Apis/Reservations/Reservations";
  import { fetchReservations } from "../../Redux/Reservations_Slice";

  const SearchSchema = Yup.object().shape({
    reservationNumber: Yup.string(),
    userName: Yup.string(),
    status: Yup.string(),
    packageId: Yup.string(),
    userId: Yup.string(),
    dateOfReservation: Yup.date().nullable(),
    isAGift: Yup.string().oneOf(["true", "false"], "Ungültiger Status"),
    payWay: Yup.string()
  });

  const ReservationsTable = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [openModal, setOpenModal] = useState(false);
    const { toastSuccess, toastError } = useToast();
    const [selectedReservation, setSelectedReservation] = useState(null);
    const [Loading, setIsLoading] = useState(false);
    const [searchFilters, setSearchFilters] = useState({});
    const { data, isLoading, error, pagination } = useSelector(
      (state) => state.Reservations
    );

    const [paginationModel, setPaginationModel] = useState({
      page: 0,
      pageSize: 10,
    });

    useEffect(() => {
      dispatch(
        fetchReservations({
          page: paginationModel.page + 1,
          limit: paginationModel.pageSize,
          filters: searchFilters
        })
      );
    }, [dispatch, paginationModel, searchFilters]);

    const handlePaginationModelChange = (newModel) => {
      setPaginationModel(newModel);
    };

    const handleImageClick = (reservation) => {
      setSelectedReservation(reservation);
      setOpenModal(true);
    };

    const handleCloseModal = () => {
      setOpenModal(false);
      setSelectedReservation(null);
    };

    const handleAccept = async () => {
      setIsLoading(true);
      try {
        const response = await FetchEditReservations(
          { isPaid: true },
          selectedReservation.id
        );
        if (response.status === 200) {
          toastSuccess("Der Prozess wurde erfolgreich abgeschlossen!");
          handleCloseModal();
          dispatch(
            fetchReservations({
              page: paginationModel.page + 1,
              limit: paginationModel.pageSize,
              filters: searchFilters
            })
          );
        }
      } catch (error) {
        toastError("Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut."); 
      } finally {
        setIsLoading(false);
      }
    };
    
    const handleDecline = async () => {
      setIsLoading(true);
      try {
        const response = await FetchEditReservations(
          { isPaid: false },
          selectedReservation.id
        );
        if (response.status === 200) {
          toastSuccess("Der Prozess wurde erfolgreich abgeschlossen!");
          handleCloseModal();
          dispatch(
            fetchReservations({
              page: paginationModel.page + 1,
              limit: paginationModel.pageSize,
              filters: searchFilters
            })
          );
        }
      } catch (error) {
        toastError("Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut."); 
      } finally {
        setIsLoading(false);
      }
    };

    const handleSearch = (values) => {
      const filters = {};
      if (values.reservationNumber) filters.reservationNumber = values.reservationNumber;
      if (values.userName) filters.userName = values.userName;
      if (values.status) filters.status = values.status;
      if (values.packageId) filters.packageId = values.packageId;
      if (values.userId) filters.userId = values.userId;
      if (values.dateOfReservation) filters.dateOfReservation = values.dateOfReservation;
      if (values.isAGift) filters.isAGift = values.isAGift;
      if (values.payWay) filters.payWay = values.payWay;
      setSearchFilters(filters);
      setPaginationModel((prev) => ({ ...prev, page: 0 }));
    };

    const handleReset = (resetForm) => {
      resetForm();
      setSearchFilters({});
      setPaginationModel((prev) => ({ ...prev, page: 0 }));
    };

    const columns = [
      {
        ...createColumn("reservationNumber", "Buchungsnummer", 150),
        renderCell: (params) => (
          <Button
            onClick={() => navigate(`ViewReservations/${params.row.id}`)}
            sx={{
              padding: 0,
              textTransform: "none",
              color: "#CD9D41",
              fontWeight: "bold"
            }}
          >
            {params.value}
          </Button>
        ),
      },
      {
        ...createColumn("userName", "Kundenname", 200),
        renderCell: (params) => (
          <Button
            onClick={() => navigate(`Kunden/ViewUsers/${params.row.userId}`)}
            sx={{ padding: 0, textTransform: "none", color: "#CD9D41" }}
          >
            {params.value}
          </Button>
        ),
      },
      {
        ...createColumn("dateOfReservation", "Datum der Reservierung", 200),
        renderCell: (params) => {
            const date = new Date(params.value);
            const day = String(date.getUTCDate()).padStart(2, '0');
            const month = String(date.getUTCMonth() + 1).padStart(2, '0');
            const year = date.getUTCFullYear();
            const hours = String(date.getUTCHours()).padStart(2, '0');
            const minutes = String(date.getUTCMinutes()).padStart(2, '0');
            
            return `${hours}:${minutes} ${day}.${month}.${year}`;
        }
      },
      {
        ...createColumn("dateEndOfReservation", "Datum Ende der Reservierung", 250),
        renderCell: (params) => {
          const date = new Date(params.value);
          const day = String(date.getUTCDate()).padStart(2, '0');
          const month = String(date.getUTCMonth() + 1).padStart(2, '0');
          const year = date.getUTCFullYear();
          const hours = String(date.getUTCHours()).padStart(2, '0');
          const minutes = String(date.getUTCMinutes()).padStart(2, '0');
          
          return `${hours}:${minutes} ${day}.${month}.${year}`;
        },
      },    
      createColumn("payWay", "Zahlungsart", 180),
      createColumn("adminNote", "adminNotiz", 250),
      createColumn("note", "Notiz", 250),
      createColumn("status", "Status", 200, "string", ({ value }) => {
        let color, label;
        if (value === "accepted" || value === "Angenommen") {
          color = "#B6E6C1";
          label = "Angenommen";
        } else if (value === "rejected" || value === "Abgelehnt") {
          color = "#E6B6B6";
          label = "Abgelehnt";
        } else {
          color = "#F0E0C0";
          label = "Ausstehend";
        }
        return (
          <span
            style={{
              backgroundColor: color,
              padding: "12px 18px",
              borderRadius: "10px",
              fontWeight: "bold"
            }}
          >
            {label}
          </span>
        );
      }),
      createColumn("codePhoto", "Bild", 250, "actions", (params) => (
        <CellImg
          onClick={() => handleImageClick(params.row)}
          src={params.value}
        />
      )),
    ];

    const Toolbar = () => (
      <Box sx={{ p: 2, bgcolor: "#D6B981" }}>
        <Formik
          initialValues={{ 
            reservationNumber: "", 
            userName: "", 
            status: "", 
            packageId: "", 
            userId: "", 
            dateOfReservation: null, 
            isAGift: "", 
            payWay: "" 
          }}
          validationSchema={SearchSchema}
          onSubmit={handleSearch}
        >
          {({ errors, touched, resetForm, setFieldValue, values, setErrors }) => (
            <Form style={{ display: "flex", alignItems: "center", gap: 20, width: "100%", justifyContent: "end" }}>
              <Field
                as={TextField}
                name="reservationNumber"
                label="Buchungsnummer"
                variant="outlined"
                size="small"
                error={touched.reservationNumber && Boolean(errors.reservationNumber)}
                helperText={touched.reservationNumber && errors.reservationNumber}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  )
                }}
              />
              <Field
                as={TextField}
                name="userName"
                label="Kundenname"
                variant="outlined"
                size="small"
                error={touched.userName && Boolean(errors.userName)}
                helperText={touched.userName && errors.userName}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  )
                }}
              />
              <Field
                as={TextField}
                select
                name="status"
                label="Status"
                variant="outlined"
                size="small"
                error={touched.status && Boolean(errors.status)}
                helperText={touched.status && errors.status}
                sx={{ minWidth: 120 }}
              >
                <MenuItem value="accepted">Angenommen</MenuItem>
                <MenuItem value="rejected">Abgelehnt</MenuItem>
                <MenuItem value="pending">Ausstehend</MenuItem>
              </Field>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                slotProps={{ textField: { size: 'small' } }}      
                disableTime
                label="Reservierungsdatum"
                value={values.dateOfReservation}
                ampm={false}
                format="dd.MM.yyyy"
                onChange={(newValue) => {
                  if (newValue) {
                    const normalizedDate = new Date(newValue);
                    normalizedDate.setHours(6, 0, 0, 0); 
                    setFieldValue("dateOfReservation", normalizedDate);
                  } else {
                    setFieldValue("dateOfReservation", null);
                  }
                  if (errors.dateOfReservation) {
                    setErrors({ ...errors, dateOfReservation: undefined });
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}

                    sx={{height:10}}
                    error={touched.dateOfReservation && Boolean(errors.dateOfReservation)}
                    helperText={touched.dateOfReservation && errors.dateOfReservation}
                  />
                )}
              />
              </LocalizationProvider>
              <Button  type="submit" variant="contained" color="inherit" size="medium">
                Suchen
              </Button>
              <Button
              sx={{fontSize:"12px",px:3}}
                type="button"
                variant="outlined"
                color="inherit"
                size="medium"
                onClick={() => handleReset(resetForm)}
              >
                Aktualisieren
              </Button>
            </Form>
          )}
        </Formik>
      </Box>
    );

    return (
      <Box>
        <MainHeader
          onNavigate={() => navigate("AddBuchungen")}
          title="Neue Buchung"
        />
        <Box sx={{ height: 600, width: "100%", mt: 3 }}>
          <DatagridTable
            columns={columns}
            rows={data || []}
            paginationModel={paginationModel}
            onPaginationModelChange={handlePaginationModelChange}
            rowCount={pagination?.total || 0}
            pageSizeOptions={[5, 10, 25]}
            loading={isLoading}
            toolbarComponent={<Toolbar />}
          />
        </Box>
        <AccoCodeModal
          open={openModal}
          onClose={handleCloseModal}
          reservation={selectedReservation}
          onAccept={handleAccept}
          onDecline={handleDecline}
          isLoading={Loading}
        />
      </Box>
    );
  };

  export default ReservationsTable;